import React, { Fragment, useContext, useEffect } from 'react';
import { Switch, Route, Link, useHistory } from 'react-router-dom';
import { appContext } from 'common/contexts';
import { Routes as R } from 'common/enums';
import { LoadScreen } from 'common/components';
import { setDocumentTitle } from 'common/utils';
import { Drawer } from './components';
import CashMovementsAdmin from './components/cashMovements/cashMovementsAdmin';
import {
  Dashboard,
  Settings,
  CategoryEditor,
  CategoryList,
  ItemList,
  OfferList,
  ItemEditor,
  TaxList,
  TaxEditor,
  OrdersList,
  UserList,
  UserEditor,
  CashierClosesList,
  // Inventory Management
  InventoryItemsList,
  InventoryItemEditor,
  StockMovementsList,
  StockMovementEditor,
  RecipesList,
  RecipeEditor,
} from './layouts';
import styles from './admin.module.css';

const Admin: React.FC = () => {
  const { state: context, actions, helpers, views } = useContext(appContext);
  const { isLoading, categories, settings, items, taxes, closedOrders, isAdmin, isEditor } = context;
  const { translation } = helpers;
  const { t } = translation;

  useEffect(() => {
    const title = [t('admin.title')];
    setDocumentTitle(title);
  }, [t]);
  useEffect(() => {
    
  }, []);
  if (isLoading) return <LoadScreen />;

  // prettier-ignore
  const routes = [
    { path: R.AdminDashboard, c: <Dashboard translation={translation} views={views} /> },
    { path: R.AdminCategoryList, c: <CategoryList categories={categories} actions={actions} /> },
    { path: R.AdminCategoryEdit, c: <CategoryEditor categories={categories} actions={actions} /> },
    { path: R.AdminCategoryCreate, c: <CategoryEditor createMode categories={categories} actions={actions} /> },
    { path: R.AdminItemList, c: <ItemList categories={categories} items={items} actions={actions} translation={translation} /> },
    { path: R.AdminOfferList, c: <OfferList categories={categories} items={items} actions={actions} translation={translation} /> },
    { path: R.AdminItemEdit, c: <ItemEditor items={items} categories={categories} taxes={taxes} actions={actions} /> },
    { path: R.AdminItemCreate, c: <ItemEditor items={items} categories={categories} taxes={taxes} actions={actions} /> },
    { path: R.AdminSettings, c: <Settings settings={settings} actions={actions} /> },
    { path: R.AdminTaxList, c: <TaxList taxes={taxes} actions={actions} /> },
    { path: R.AdminTaxEdit, c: <TaxEditor taxes={taxes} actions={actions} /> },
    { path: R.AdminTaxCreate, c: <TaxEditor taxes={taxes} actions={actions} /> },
    { path: R.OrdersList, c: <OrdersList orders={closedOrders} actions={actions}  translation={translation} items={items} context={context} />},
    { path: R.CashierClosesList, c: <CashierClosesList translation={translation} />},
    { path: R.AdminUsersList, c: <UserList context={context} translation={translation} /> },
    { path: R.AdminUserCreate, c: <UserEditor context={context} translation={translation} createMode /> },
    { path: R.AdminUserEdit, c: <UserEditor context={context} translation={translation} /> },
    // Inventory Management Routes
    { path: R.InventoryItemsList, c: <InventoryItemsList /> },
    { path: R.InventoryItemCreate, c: <InventoryItemEditor /> },
    { path: R.InventoryItemEdit, c: <InventoryItemEditor /> },
    { path: R.StockMovementsList, c: <StockMovementsList /> },
    { path: R.StockMovementCreate, c: <StockMovementEditor /> },
    { path: R.RecipesList, c: <RecipesList /> },
    { path: R.RecipeCreate, c: <RecipeEditor /> },
    { path: R.RecipeEdit, c: <RecipeEditor /> },
  ];

  // Modo unificado para todos los roles, el drawer mostrará las opciones según el rol del usuario
  return (
    <div className={styles.root}>
      <Switch>
        <Fragment>
          <div className={styles.nav}>
            <Drawer translation={translation} />
          </div>
          <div className={styles.content}>
            {routes.map((route) => (
              <Route key={route.path} exact path={route.path}>
                {route.c}
              </Route>
            ))}
            <Route path="/admin/cash-movements" component={CashMovementsAdmin} />
          </div>
        </Fragment>
      </Switch>
    </div>
  );
};

export default Admin;
